import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ILocale } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { getScreenExtraReducers } from "ui/app";
import { IPickerSearchCriterion } from "ui/shared/helpers/plex-components";

import { getAppLanguageSwitchInitialState, IAppLanguageSwitchState } from "./AppLanguageSwitch.state";

const initialState = getAppLanguageSwitchInitialState();

export const appLanguageSwitch = createSlice({
  name: "appLanguageSwitch",
  initialState: initialState,
  reducers: {
    loadSupportedLocales: state => {
      return {
        ...state,
        supportedLocales: undefined,
        isLoading: true
      };
    },
    loadSupportedLocalesCompleted: (state, action: PayloadAction<ILocale[]>) => {
      return { ...state, isLoading: false, supportedLocales: action.payload };
    },
    loadSupportedLocalesFailed: (state, action: PayloadAction<INotification>) => {
      return { ...state, isLoading: false, notifications: [...state.notifications, action.payload] };
    },
    loadSearchedLocales: (state, _: PayloadAction<IPickerSearchCriterion<ILocale>>) => {
      return {
        ...state,
        isLoading: true
      };
    },
    loadSearchedLocalesCompleted: (state, action: PayloadAction<ILocale[]>) => {
      return { ...state, isLoading: false, searchedLocales: action.payload };
    },
    loadSearchedLocalesFailed: (state, action: PayloadAction<INotification>) => {
      return { ...state, isLoading: false, notifications: [...state.notifications, action.payload] };
    },
    resetState: () => {
      return getAppLanguageSwitchInitialState();
    }
  },
  extraReducers: getScreenExtraReducers<IAppLanguageSwitchState>("notifications", initialState)
});
